<template>
  <div class="content">
    <template v-if="!isDeatil">
      <Selection :className="['flexEnd']" ref="selection" class="selection" @handleChange="handleChange" />
      <div class="inner" :class="tabKey === 4 ? 'lesson' : ''">
        <div class="res-list" v-if="respagination.total > 0">
          <div class="list">
            <div :class="['item', item.isAbate ? 'isAbate' : '']" :key="item.id" v-for="item in reslist">
              <div class="cover">
                <img :src="item.cover" @click="detail(item.targetId)" :class="item.type === 'model' ? 'model' : ''" />
                <span class="type">{{ reversedNameMap[item.subType] }}</span>
                <div class="mask">
                  <h4>{{ $t('personal.resource.status.invalid') }}</h4>
                  <a href="javascript:void(0)" @click="remove(item)">{{ $t('personal.resource.status.delete') }}</a>
                </div>
                <div class="modal" v-if="item.subType === 'software' && !item.isAbate">
                  <div class="button" @click.stop="openApp(item)">{{ $t('personal.resource.button.openSoftware') }}</div>
                </div>
              </div>
              <div class="title" @click="detail(item.targetId)">{{ item.name || item.title }}</div>
              <div class="desc">{{ item.createdAt }}</div>
            </div>
          </div>
          <Pagination class="list-pagination" :pagination.sync="respagination" @handleTableChange="handleTableChange" />
        </div>
        <template v-else>
          <Empty v-if="isSeacher" :imgSrc="require('@/assets/img/bj_zanwu.png')" :text="$t('personal.resource.noData')" :isSearch="true" />
          <Empty v-else :imgSrc="require('@/assets/img/bj_zanwu@2x.png')" :text="$t('personal.resource.noData')" />
        </template>
      </div>
      <Modal :visible.sync="visible" />
    </template>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import Empty from '@/components/Empty/index'
import TipModal from '@/components/tipModal/index'
import Selection from './Selection.vue'
import Modal from '@/components/XRInfoModal/index'
import Pagination from '@/components/pagination/index.vue'
import { resTypeMap, getFavoritesResource, resourceUnlike, resourceUncollect } from '@/api/lesson'

export default {
  components: {
    Empty,
    TipModal,
    Selection,
    Pagination,
    Modal
  },
  data() {
    return {
      tabKey: 3,
      id: undefined,
      resTypeList: [],
      backVisible: false,
      saveVisible: false,
      clearVisible: false,
      prepareName: undefined,
      selected: {
        resType: undefined,
        resTitle: undefined,
        interactionType: 1
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        hideOnSinglePage: true
      },
      reslist: [],
      respagination: {
        page: 1,
        pageSize: 8,
        total: 0
      },
      isDeatil: false,
      isCourseware: false,
      isSeacher: false,
      visible: false,
      reversedNameMap: {
        text: this.$t('personal.resource.resourceType.text'),
        image: this.$t('personal.resource.resourceType.image'),
        audio: this.$t('personal.resource.resourceType.audio'),
        video: this.$t('personal.resource.resourceType.video'),
        model: this.$t('personal.resource.resourceType.model'),
        software: this.$t('personal.resource.resourceType.software')
      }
    }
  },
  computed: {
    noPrepareData() {
      if (this.list.length === 0) return false
      const index = this.list.findIndex(item => {
        return item.resList && item.resList.length > 0
      })
      return index === -1
    }
  },
  methods: {
    handleTableChange() {
      this.getResList()
    },
    handleTypeChange(key) {
      this.tabKey = key
      this.$refs.selection.handleTypeChange(key)
    },
    handleChange(obj) {
      this.respagination.page = 1
      this.selected = Object.assign(this.selected, {
        subType: obj.resType,
        resTitle: obj.keyword,
        interactionType: obj.interactionType
      })
      this.isSeacher = obj.keyword ? true : false
      this.getResList()
    },
    getResList() {
      const data = Object.assign(this.selected, {
        type: this.tabKey,
        page: this.respagination.page,
        pageSize: this.respagination.pageSize
      })
      getFavoritesResource(data).then(res => {
        if (res.code != 200) return
        this.reslist = res.data.list
        this.respagination.total = res.data.total
        console.log('this.reslist ----->', this.reslist)
        this.setResourceCover()
      })
    },
    getResTypeMap() {
      resTypeMap().then(res => {
        this.resTypeList = res.data.list
      })
    },
    detail(id) {
      switch (this.tabKey) {
        case 2:
          //  type  1课程 2共享资源 3个人资源 4校级资源
          this.$router.push({ name: 'resourceDetail', query: { id, resType: 2 } })
          break
        case 3:
          this.$router.push({ name: 'resourcePrivateDetails', query: { id, resType: 3 } })
          break
      }
    },
    async remove(obj) {
      const params = {
        res_id: obj.targetId,
        type: this.tabKey
      }
      if (obj.interactionType === '1') {
        await resourceUncollect(params)
        this.$message.success(this.$t('personal.resource.message.cancelCollect'))
      } else {
        await resourceUnlike(params)
        this.$message.success(this.$t('personal.resource.message.cancelLike'))
      }
      this.getResList()
    },
    setResourceCover() {
      this.reslist.forEach(item => {
        if (item.cover) return
        switch (item.subType) {
          case 'text':
            item.cover = require('@/assets/img/bg_text_cover.png')
            break
          case 'audio':
            item.cover = require('@/assets/img/bg_auido_cover.png')
            break
          case 'model':
            item.cover = require('@/assets/img/bj_mx@2x.png')
            break
          case 'software':
            item.cover = require('@/assets/img/bj_sx@2x.png')
            break
        }
      })
    },
    openApp(obj) {
      this.checkedItem = obj
      this.Ok(obj)
    },
    Ok(obj) {
      console.log('obj ----->', obj)
      const userType = cookie.getJSON('user_type').join(',')
      const data = {
        data: Object.assign(cookie.getJSON('user_infor'), {
          resId: obj.targetId,
          token: localStorage.token,
          roles: cookie.getJSON('user_type'),
          type: 'openRes',
          roomId: '',
          playerId: '',
          source_type: this.tabKey === 2 ? 1 : 2, // 1校本 2个人
          school_type: userType.includes('external') ? 2 : 1 // 1校内 2校外
        })
      }
      console.log('------->', data)
      // 一键打开应用程序
      // 检测用户的设备是否是Windows系统
      if (/windows|win32/i.test(navigator.userAgent)) {
        // 检测用户的浏览器是否能使用universalLink
        let openApp = false
        const userAgent = navigator.userAgent
        // 判断是否 Firefox浏览器
        if (userAgent.indexOf('Firefox') > -1) {
          openApp = true
        }
        // 判断是否 Chrome浏览器
        if (userAgent.indexOf('Chrome') > -1) {
          openApp = true
        }
        // 判断是否 Edge浏览器
        if (userAgent.indexOf('Edg') > -1) {
          openApp = true
        }
        if (openApp) {
          try {
            this.openUriWithInputTimeoutHack(
              process.env.VUE_APP_XR_NAME + '://' + encodeURIComponent(JSON.stringify(data)),
              error => {
                this.visible = true
                // this.$message.error('软件未安装！')
              },
              success => {
                this.visible = false
                this.checkedItem = null
                // console.log('软件已安装！')
              }
            )
          } catch (err) {
            console.log(err)
            this.$message.warning('出错了，请手动打开软件！')
          }
        }
      }
    },
    openUriWithInputTimeoutHack(url, failCb, successCb) {
      const target = document.createElement('input')
      target.style.width = '0'
      target.style.height = '0'
      target.style.position = 'fixed'
      target.style.top = '0'
      target.style.left = '0'
      document.body.appendChild(target)

      target.focus()
      const handler = this.registerEvent(target, 'blur', onBlur)

      function onBlur() {
        successCb && successCb()
        handler.remove()
        clearTimeout(timeout)
        document.body.removeChild(target)
      }

      location.href = url
      console.log('url ----->', url)

      const timeout = setTimeout(function() {
        failCb && failCb()
        handler.remove()
        document.body.removeChild(target)
      }, 1000)
    },
    registerEvent(target, eventType, cb) {
      if (target.addEventListener) {
        target.addEventListener(eventType, cb)
        return {
          remove: function() {
            target.removeEventListener(eventType, cb)
          }
        }
      } else {
        target.attachEvent(eventType, cb)
        return {
          remove: function() {
            target.detachEvent(eventType, cb)
          }
        }
      }
    }
  },
  activated() {
    this.isDeatil = false
    this.isCourseware = false
  },
  created() {
    this.getResList()
  }
}
</script>

<style lang="less" scoped>
.content {
  .tabs {
    height: 35px;
    display: flex;
    position: absolute;
    border-radius: 20px;
    background: #edf3fa;
    .tab-name {
      height: 100%;
      cursor: pointer;
      padding: 0 32px;
      color: #6b738c;
      font-size: 14px;
      line-height: 35px;
      border-radius: 20px;
    }
    .tab-name.selected {
      color: #fff;
      background: #f27529;
    }
  }
  .inner {
    height: calc(100vh - 347px);
    overflow-y: auto;
  }
  .res-list {
    height: 97%;
    padding: 10px 0 40px;
    position: relative;
    .list {
      width: 100%;
      display: flex;
      padding: 10px;
      flex-wrap: wrap;
      max-height: 100%;
      overflow-y: auto;
      .item {
        display: flex;
        margin-top: 30px;
        margin-right: 20px;
        position: relative;
        border-radius: 6px;
        flex-direction: column;
        width: calc((100% - 60px) / 4);
        .cover {
          width: 100%;
          cursor: pointer;
          margin-bottom: 6px;
          border-radius: 6px;
          position: relative;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
          .type {
            left: 0;
            top: 8px;
            min-width: 70px;
            height: 23px;
            padding: 0 5px;
            cursor: pointer;
            font-size: 11px;
            font-weight: 400;
            color: #28383b;
            line-height: 23px;
            text-align: center;
            position: absolute;
            border-radius: 0px 4px 4px 0px;
            background: linear-gradient(224deg, #eceff0 0%, #c6c9cd 100%);
          }
          .mask {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            background-color: rgba(0, 0, 0, 0.5);
            border-radius: 6px;
            display: none;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            h4 {
              font-size: 20px;
              color: #fff;
              font-style: italic;
            }
            a {
              color: #ffb214;
              font-size: 12px;
            }
          }
          .modal {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            border-radius: 6px;
            position: absolute;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, 0.6);
            .button {
              min-width: 80px;
              height: 30px;
              padding: 0 6px;
              font-size: 12px;
              font-weight: 400;
              color: #ffffff;
              line-height: 30px;
              text-align: center;
              background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%);
              box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
              border-radius: 6px;
            }
          }
          &:hover .modal {
            display: flex;
            z-index: 999;
          }
        }
        .cover.model {
          border-radius: 6px;
          background: url('~@/assets/img/bj_model.png') no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }

        .type {
          left: 0;
          top: 8px;
          min-width: 70px;
          height: 23px;
          cursor: pointer;
          font-size: 11px;
          font-weight: 400;
          color: #28383b;
          line-height: 23px;
          text-align: center;
          position: absolute;
          border-radius: 0px 4px 4px 0px;
          background: linear-gradient(224deg, #eceff0 0%, #c6c9cd 100%);
        }
        .title {
          width: 100%;
          color: #000;
          font-size: 15px;
          cursor: pointer;
          overflow: hidden;
          font-weight: 550;
          line-height: 20px;
          margin-bottom: 6px;
          position: relative;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 6px 0 3px 12px;
        }
        .desc {
          width: 100%;
          height: 20px;
          font-size: 12px;
          cursor: pointer;
          overflow: hidden;
          font-weight: 400;
          color: #000000;
          line-height: 19px;
          padding-left: 12px;
          margin-bottom: 6px;
          position: relative;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .button-add {
          width: 90px;
          height: 27px;
          font-size: 14px;
          cursor: pointer;
          font-weight: 400;
          color: #ffffff;
          line-height: 27px;
          padding: 0 14px;
          margin-left: 12px;
          margin-bottom: 12px;
          border-radius: 6px;
          text-align: center;
          border-radius: 6px;
          display: inline-block;
          box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
          background: linear-gradient(248deg, #ff6d00 0%, #f58623 100%);
        }
        .button-add.authorizated {
          width: 70px;
          background: linear-gradient(227deg, #72899d 0%, #9bb3c8 100%);
        }
        .button-add.checked {
          width: 70px;
          color: #75767a;
          box-shadow: none;
          background: #e9e9e9;
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:nth-child(-n + 4) {
          margin-top: 0;
        }
      }
      .item:hover .title {
        color: #ff6d00;
      }
      .isAbate {
        .title,
        .desc {
          color: #999 !important;
        }
        .cover {
          .mask {
            display: flex;
          }
        }
      }
    }
    .list-pagination {
      width: 100%;
      bottom: 30px;
      position: absolute;
    }
  }
}
@media screen and(min-width: 1700px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 190px;
            }
          }
        }
      }
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 172px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1400px) and (max-width: 1500px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 146px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1400px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 132px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 127px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 109px;
            }
          }
        }
      }
    }
  }
}
</style>
